import { Link } from "react-router-dom";

export function Wordmark({ to, className = "", inverted = false }) {
  const content = (
    <img
      src={inverted ? "/brand/metworth-light.png" : "/brand/metworth-dark.png"}
      alt="MetWorth"
      data-testid="wordmark-logo"
      className={`block h-6 w-auto sm:h-7 ${className}`}
    />
  );
  if (!to) return content;
  return (
    <Link to={to} data-testid="wordmark-link" aria-label="MetWorth home" className="inline-block">
      {content}
    </Link>
  );
}
